import { combineReducers } from 'redux';

import { apiEvent, apiEventInitial } from './apiEvent';
import { attachments, attachmentsInitial } from './attachments';
import { common, commonInitialState } from './common';
import { customer } from './customer';
import { dialog, dialogInitial } from './dialog';
import { editInitial, editMode } from './editMode';
import { fieldError, fieldErrorInitial } from './fieldError';
import { multiRequest, multiRequestInitialState } from './multiRequest';
import { odata, odataInitialState } from './odata';
import { signgleRecordInitial, singleRecord } from './singleRecord';
export { default as StoreProvider } from './StoreProvider';
export { StoreContext } from './StoreProvider';
export { withStore } from './withStore';

// Inital State
export const storeInitialState = {
  editMode: editInitial,
  dialog: dialogInitial,
  attachments: attachmentsInitial,
  apiEvent: apiEventInitial,
  fieldError: fieldErrorInitial,
  odata: odataInitialState,
  common: commonInitialState,
  multiRequest: multiRequestInitialState,
  singleRecord: signgleRecordInitial
};

export const appReducer = combineReducers({
  customer,
  dialog,
  attachments,
  editMode,
  apiEvent,
  fieldError,
  odata,
  common,
  multiRequest,
  singleRecord
});

export const reducer = (state, action) => {
  if (action.type === 'RESET_STORE') {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};
